import type { ReactNode } from "react";
import { useEffect } from "react";
import { Icon } from "./Icon";

export function Sheet({ title, children, onClose }: { title: string; children: ReactNode; onClose: () => void }) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => { if (event.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="sheet-backdrop" role="presentation" onMouseDown={(event) => { if (event.currentTarget === event.target) onClose(); }}>
      <section className="sheet" role="dialog" aria-modal="true" aria-labelledby="sheet-title">
        <div className="sheet__handle" />
        <header><h2 id="sheet-title">{title}</h2><button type="button" className="icon-button" onClick={onClose} aria-label="Close"><Icon name="x" /></button></header>
        <div className="sheet__content">{children}</div>
      </section>
    </div>
  );
}
